<div *ngIf="hcpsCount > 0" class="mt-4">
  <app-common-table
    [params]="params"
    [title]="'Healthcare professionals (HCPs)'"
  ></app-common-table>
</div>
